"use strict";

export var FormEditConstants = {
  FORM_EDIT_INITIALIZE: 'FORM_EDIT_INITIALIZE',
  LOAD_BUTTONS_DATA: 'LOAD_BUTTONS_DATA',
  FORM_EDIT_NAVIGATE_TO_PARENT: 'FORM_EDIT_NAVIGATE_TO_PARENT',
  FORM_EDIT_SUBMIT: 'FORM_EDIT_SUBMIT',
  FORM_EDIT_UPDATE: 'FORM_EDIT_UPDATE',
  FORM_EDIT_DESTROY: 'FORM_EDIT_DESTROY',
  FORM_EDIT_SUBMITED: 'FORM_EDIT_SUBMITED',
  FORM_EDIT_NESTED_FORM_LOADED: 'FORM_EDIT_NESTED_FORM_LOADED',
  RENDER_DETAILS: 'RENDER_DETAILS',
  LOAD_TABLE_CONTEXT_MENU_DATA: 'LOAD_TABLE_CONTEXT_MENU_DATA',
  FORM_EDIT_UPDATE_SUBFORM: 'FORM_EDIT_UPDATE_SUBFORM'
};